import React from 'react';
import './styles.css';
import {
    banco,
    compras,
    conta,
    cxp,
    inventario,
    presupuesto,
    ventas
} from './ERP/imagenesERP'

export default function DescripcionERPFondo(props){


    return(<>
     <div className='contenedorDescripcionERPFondo'>
        <div className='contenedorGeneralDescripcionERPFondo'>
        <div className='contenedorTituloDescripcionERPFondo'>
            <p>¿POR QUÉ ADQUIRIR T&T ERP?</p>
        </div>
        <div className='caracteristicasDescripcionERPFondo'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={inventario}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>Inventarios</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={compras}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>Compras</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={ventas}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>Ventas</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={cxp}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>C x P</p>
                </div>
            </div>
        </div>

        <div className='caracteristicasDescripcionERPFondo'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={banco}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>Bancos</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={conta}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>Contabilidad</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionERPFondo'>
                    <img src={presupuesto}/>
                </div>
                <div className='contenedorDescripcionERPFondoImagen'>
                    <p>Presupuestos</p>
                </div>
            </div>
        </div>
    </div>
</div>
    </>)
}